module.exports = __webpack_public_path__ + "img/2c72d89fb1ecb4a2896c6f92e92c582c.svg";